import { render, staticRenderFns } from "./RubricLinkRenderer.vue?vue&type=template&id=2f5a160f&"
import script from "./RubricLinkRenderer.vue?vue&type=script&lang=js&"
export * from "./RubricLinkRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports